import { render, staticRenderFns } from "./newCase.vue?vue&type=template&id=5be2078d&scoped=true"
import script from "./newCase.js?vue&type=script&lang=js&external"
export * from "./newCase.js?vue&type=script&lang=js&external"
import style0 from "./newCase.vue?vue&type=style&index=0&id=5be2078d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2078d",
  null
  
)

export default component.exports